import {
  BookingsApi,
  Configuration,
  GetAllBookingsRequest,
  GetAllBookingsStatusEnum,
  ViewBooking
} from "collins-js-sdk";
import { mergeBookings } from "../../utils/booking";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { convertAllDatesToUTC } from "../../utils/helpers";
import { ViewBookingFromJSONWithAdditionalProps } from "../../utils/viewBookingWrapper";
import { errorHandler } from "../errorHandler";

/**
 * Get the bookings from the API
 * @returns
 */
export const fetchBookingsFromAPI = async (
  props: GetAllBookingsRequest,
  additionalProps?: Record<string, unknown>
) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  // Convert all Date params to UTC
  const params = convertAllDatesToUTC(props);

  const config = new Configuration({
    accessToken: token,
    basePath: environmentVars?.COLLINS_API_BASE_URL,
    headers: {
      "Access-Control-Allow-Origin": "*"
    },
    queryParamsStringify: (params) => {
      const result = Object.keys(params)
        .map((key) => {
          const value = params[key as keyof typeof params];
          return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join("&");

      if (additionalProps) {
        const additionalString = Object.keys(additionalProps)
          .map((key) => {
            const value = additionalProps[key as keyof typeof additionalProps];
            return `${encodeURIComponent(key)}=${encodeURIComponent(
              String(value)
            )}`;
          })
          .join("&");
        return `${result}&${additionalString}`;
      }
      return result;
    }
  });

  try {
    if (additionalProps) {
      const rawResponse = await new BookingsApi(config).getAllBookingsRaw(
        params
      );
      const rawData = await rawResponse.raw.json();
      if (rawData.bookings) {
        const bookingsWithTags = rawData.bookings.map((booking: any) => {
          return ViewBookingFromJSONWithAdditionalProps(booking);
        });
        return bookingsWithTags;
      }
    }

    const response = await new BookingsApi(config).getAllBookings(params);
    return response.bookings;
  } catch (error) {
    errorHandler(error, "Error fetching bookings");

    return undefined;
  }
};

export const selectedDateBookingList = async (date: Date, venueId?: string) => {
  if (!date || !venueId) {
    return undefined;
  }
  const fields = "+tags,+customer_labels";
  const additionalProps = { fields, include_preorders: true };
  let newBookings = [];
  let isNewBookingApiCalledDone = false;
  let pageNumberNewBooking = 1;
  let allbookings: ViewBooking[] = [];

  do {
    newBookings =
      (await fetchBookingsFromAPI(
        {
          date: date,
          venueId: [venueId],
          status: [
            GetAllBookingsStatusEnum.New,
            GetAllBookingsStatusEnum.InProgress,
            GetAllBookingsStatusEnum.Complete,
            GetAllBookingsStatusEnum.Rejected
          ],
          page: pageNumberNewBooking.toString()
        },
        additionalProps
      )) || [];
    if (newBookings.length !== 30) {
      isNewBookingApiCalledDone = true;
      allbookings = mergeBookings(allbookings, newBookings);
    } else {
      pageNumberNewBooking = pageNumberNewBooking + 1;
      allbookings = mergeBookings(allbookings, newBookings);
    }
  } while (!isNewBookingApiCalledDone);

  return allbookings;
};
